import { Drawer } from "@mui/material";
import { useWasteLineUnifiedSuspense } from "hooks/useWasteLineUnified";
import { Suspense } from "react";

import {
  ManifestDetailSection,
  ManifestDetailSectionSkeleton,
} from "../Manifests/ManifestDetailSection";
import { ManifestLineItemDetailSection } from "./ManifestLineItemDetailSection";

interface ManifestLineItemDetailProps {
  lineItemId: string | undefined;
  open: boolean;
  onClose: () => void;
}

export function ManifestLineItemDetail({ lineItemId, open, onClose }: ManifestLineItemDetailProps) {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      sx={{
        "& .MuiDrawer-paper": {
          width: { xs: "100%", sm: 600, md: 800, lg: 1000 },
          boxSizing: "border-box",
        },
      }}
    >
      <Suspense fallback={<ManifestDetailSectionSkeleton />}>
        <ManifestLineItemDetailContent lineItemId={lineItemId} onClose={onClose} />
      </Suspense>
    </Drawer>
  );
}

const ManifestLineItemDetailContent = ({
  lineItemId,
  onClose,
}: {
  lineItemId: string | undefined;
  onClose: () => void;
}) => {
  const { lineItem } = useWasteLineUnifiedSuspense(lineItemId);
  return (
    <ManifestDetailSection processedManifestId={lineItem?.processedManifestId} onClose={onClose}>
      <ManifestLineItemDetailSection
        processedManifestId={lineItem?.processedManifestId}
        lineItemId={lineItemId}
        backButtonText="Back to all line items"
        onBackButtonClick={onClose}
      />
    </ManifestDetailSection>
  );
};
